import { combineReducers } from "redux";
import global from './global';
import posts from './posts';
import auth from './auth';

export default combineReducers({
    global,
    posts,
    auth,
});